module.exports = __webpack_public_path__ + "static/media/image-add.d078de2e.png";